import React from "react";

export default function Social() {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/you2_know_me/"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-instagram"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/abhilash-r-89ba451b0/"
        className="home__social-icon"
        target="_blank"
      >
        <i className="bx bxl-linkedin"></i>
      </a>
      <a
        href="https://steamcommunity.com/id/azazelmax4/"
        className="home__social-icon"
        target="_blank"
      >
        <i className="bx bx-joystick"></i>
      </a>
    </div>
  );
}
